import { List, Map } from 'immutable';
import { DEFAULT_SESSION_ID, DEFAULT_PER_PAGE } from '../constants';
import { orderListActions } from './actions';
import { OrderList } from './order-list';

export const initialState = new Map({
  currentOrderListId: DEFAULT_SESSION_ID,
  [DEFAULT_SESSION_ID]: new OrderList({id: DEFAULT_SESSION_ID, isNew: false})
});

export function orderListsReducer(state = initialState, action) {

  const { type, payload } = action;
  switch (type) {
    case orderListActions.FETCH_ORDERS_SUCCESS:
    case orderListActions.FETCH_ORDERS_PENDING:
      return state.set(
        payload.orderListId,
        orderListReducer(state.get(payload.orderListId), action)
      );
    case orderListActions.LOAD_ORDERS:
      return state.merge({
        currentOrderListId: payload.orderListId,
        [payload.orderListId]: orderListReducer(state.get(payload.orderListId), action)
      });
    case orderListActions.UPDATE_PAGINATION:
        return state.set(
          state.get('currentOrderListId'),
          orderListReducer(state.get(state.get('currentOrderListId')), action)
        );
    default:
      return state;
  }
}

export const orderListReducer = (state = new OrderList() , { payload, type }  ) => {
  switch (type) {
    case orderListActions.FETCH_ORDERS_SUCCESS:
     return state.withMutations(orderList => {
       orderList
        .merge({
          isNew:false,
          isPending:false,
          total: payload.total,
          nextUrl: payload.next_page_url || null,
          prevUrl: payload.prev_page_url || null,
          orderIds: mergeIds(orderList.orderIds, payload.data),
          created_at: new Date()
       })
       .merge(updatePagination(orderList, orderList.currentPage + 1));
      });
    case orderListActions.FETCH_ORDERS_PENDING:
      return state.set('isPending', true);
    case orderListActions.LOAD_ORDERS:
      return state.withMutations(orderList => {
        orderList
          .merge({
            id: payload.orderListId,
            filters: payload.filters,
          })
          .merge(updatePagination(orderList, 1));
        });
    case orderListActions.UPDATE_PAGINATION:
      return state.merge(updatePagination(state, payload.page));
    default:
      return state;
  }
}

function mergeIds(orderIds, items) {
  let ids = orderIds.toJS();

  let newIds = items.reduce((list, sucursalData) => {
    if (ids.indexOf(sucursalData.id) === -1) list.push(sucursalData.id);
    return list;
  }, []);

  return newIds.length ? new List(ids.concat(newIds)) : orderIds;
}

function updatePagination(orderList, page) {
  let pageCount = Math.ceil(orderList.orderIds.size / DEFAULT_PER_PAGE);
  let currentPage = Math.min(page, pageCount);
  let hasNextPageInStore = currentPage < pageCount;
  let hasPrevPage = currentPage > 1;
  let hasNextPage = hasNextPageInStore || orderList.nextUrl !== null;

  let to = currentPage * DEFAULT_PER_PAGE
  let from = (to - DEFAULT_PER_PAGE) + 1

  if ( orderList.total < to )
    to = orderList.total

  if (from < 1)
    from = 1

  return {
    currentPage,
    hasNextPage,
    hasNextPageInStore,
    hasPrevPage,
    pageCount,
    to,
    from
  };
}
